import React from 'react'

import { Dialog } from 'src/chrome'
import { MinimalCampaignFragment } from 'src/graphql'

import SelectCampaign from './SelectCampaign'
import styles from './GroupAddCreate/groupAddCreate.module.scss'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import { Text } from '@sendoutcards/quantum-design-ui'

type SelectCampaignModalProps = {
  isOpen: boolean
  onClose: () => void
  onSubmit: (campaign: MinimalCampaignFragment) => void
}

const SelectCampaignModal: React.FC<SelectCampaignModalProps> = props => {
  const { onSubmit, onClose, isOpen } = props
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      scroll={'paper'}
      style={{ transition: '300ms' }}
    >
      <DialogTitle>
        <Text type="body" color="primaryHeading">
          {'Select Campaign to Send'}
        </Text>
      </DialogTitle>
      <DialogContent className={styles.modalContent}>
        <SelectCampaign onClose={onClose} onSubmit={onSubmit} />
      </DialogContent>
    </Dialog>
  )
}

export default SelectCampaignModal
